export const getNavigationPath = (path: string, isPreview: boolean) => {
  const searchParams = isPreview ? "?isPreview=true" : ""
  return `${path}${searchParams}`
}
